import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

const SuccessDialog = ({ open, shortId, email, onClose }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <Dialog open={open} onClose={onClose} className="cash-wallet-success-dialog">
            <DialogTitle className="cash-wallet-success-title">{t('Success.Title')}</DialogTitle>
            <DialogContent>
                <div className="cash-wallet-success-id">
                    <Trans
                        t={t}
                        i18nKey="Success.PaymentRequestId"
                        values={{ shortId }}
                        components={[<strong key="0" className="cash-wallet-success-id-strong" />]}
                    />
                </div>
                <div className="cash-wallet-success-body">{t('Success.Body', { email })}</div>
            </DialogContent>
            <DialogActions>
                <Button className="cash-wallet-success-cta" variant="contained" color="primary" onClick={onClose}>
                    {t('Success.GotIt')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SuccessDialog;
